import { gql } from '@apollo/client'

export const searchPromoCode = gql`
  query SearchPromoCode($code: String) {
    promoCodeFindOne(filter: { code: $code }) {
      code
      stripeID
      whoCanUse
      type
      amount
    }
  }
`
